module.exports = __webpack_public_path__ + "static/prlaw-square-a5ab36d1636f2e79e0aef94d443745ca.jpg";